// File: src/components/common/LoadingFallback.js
// -----------------------------------------------------
import React from 'react';
import { Box } from '@mui/material';
import BrandLoader from '../progressBar/BrandLoader';

/**
 * Loading fallback component for React.Suspense
 */
const LoadingFallback = ({ message = 'Loading...' }) => {
  return (
    <Box 
      sx={{ 
        display: 'flex', 
        flexDirection: 'column',
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '100vh' 
      }}
    >
      <BrandLoader size={120} message={message} />
    </Box>
  );
};

export default LoadingFallback;